import { AlertTriangleIcon } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function QuotaInconsistentBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="destructive"
      className={cn('gap-1', className)}
      data-testid="quota-missing-badge"
    >
      <AlertTriangleIcon className="size-3" />
      Quota manquant
    </Badge>
  );
}

export function AccountTypeBadge({
  accountType,
  quotaMissing = false,
}: {
  accountType: 'demo' | 'subscriber';
  quotaMissing?: boolean;
}) {
  if (accountType === 'demo' && quotaMissing) {
    return <QuotaInconsistentBadge />;
  }

  if (accountType === 'demo') {
    return (
      <Badge className="border-transparent bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300">
        Démo
      </Badge>
    );
  }

  return <Badge variant="secondary">Abonné</Badge>;
}
